<template>
  <div>
    <div
      v-for="(item, index) of filter"
      :key="index"
      class="d-flex filter-item my-1"
    >
      <v-btn icon class="filter-icon" tile @click="deleteFilter(index)">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
      <field-group
        no-label
        v-if="!fields || fields.length < 1"
        v-model="item.first"
        class="filter-input mx-1"
        @input="updateFilter"
      ></field-group>
      <field-group
        no-label
        v-else
        v-model="item.first"
        class="filter-input mx-1"
        type-input="v-select"
        @input="updateFilter"
        item-text="name"
        item-value="code"
        :items="fields"
      ></field-group>
      <field-group
        no-label
        v-model="item.opt"
        class="filter-opt mx-1"
        type-input="v-select"
        @input="updateFilter"
        :items="optItems"
      ></field-group>
      <field-group
        no-label
        v-model="item.second"
        class="filter-input mx-1"
        @input="updateFilter"
      ></field-group>
    </div>
    <div class="d-flex my-1">
      <v-spacer></v-spacer>
      <v-btn outlined tile @click="addFilter" class="text-none">
        {{ $t('preview.actions.add') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: { value: { type: Array }, fields: { type: Array } },
  data: () => ({
    optItems: ['=', '<>', '>', '>=', '<', '<='],
    filter: [],
  }),
  watch: {
    value: {
      handler(value) {
        this.filter = value
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    addFilter() {
      const filter = this.filter || []
      this.$emit('input', [...filter, { first: 'name', opt: '=', second: '0' }])
    },
    deleteFilter(index) {
      const filter = this.filter || []
      filter.splice(index, 1)
      this.$emit('input', filter)
    },
    updateFilter() {
      this.$emit('input', this.filter)
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-item {
  width: 100%;
  flex-direction: row;
  display: flex;
  .filter-opt {
    flex: 75px;
  }
  .filter-input {
    flex: 1 1 auto;
    max-width: 150px;
  }
}
</style>
